// TODO: Fix Paths
import * as paths from '../constants/path';

export default paths

// Export the helper function for determining API prefix
export { getApiPrefix } from "../constants/path"
